<style lang="less" scoped>
  @import "../../../vars.less";

  .update-time {
    margin: 0;
    color: @text-color-secondary;
    font-size: 12px;
    font-style: italic;
    padding: @space-normal;
  }

  .material-list {
    padding: @space-normal;
    font-size: 12px;
    line-height: 1.8;
    background-color: #fff;
  }
  .material-item:not(:last-child) {
    padding-bottom: @space-medium;
  }
  .material-item:not(:last-child) {
    padding-bottom: @space-medium;
    margin-bottom: @space-medium;
  }
  .material-item:last-child:after {
    display: none;
  }
  .material-title {
    margin: 0 0 @space-small 0;
    color: @primary-color;
    font-size: 14px;
    font-weight: 500;
  }
  .material-line {
    display: flex;
    justify-content: center;
    margin: 0;
  }
  .material-line-left {
    flex: auto;
  }
  .material-line-right {
    flex: none;
  }
  .secondary {
    color: @text-color-secondary;
  }
  .label {
    color: @text-color-secondary;
    margin-right: 4px;
    font-weight: normal;
    &:after {
      content: ':'
    }
  }
  .table {
    width: 100%;
    padding-left: @space-normal;
    th, td {
      // text-align: center;
      font-weight: normal;
    }
  }
</style>

<template>
  <page-container :loading="loading"
    infinity :finished="finished" :empty="!list.length"
    :title="$t('库存详情')" @load="getStock"
    class="stock-query-result">
    <p class="update-time">
      <span>
        {{ $t('数据更新日期') }}:
      </span>
      <span v-show="!updateDateLoading">
        {{ updateDate || $t('暂无数据更新日期') }}
      </span>
      <van-loading v-if="updateDateLoading" class="loading" size="14px" />
    </p>
    <ul class="material-list" v-show="!!list.length">
      <li v-for="(item, index) of list" :key="item.materialNumber"
        class="material-item" :class="{ 'van-hairline--bottom': index === list.length - 1}">
        <p class="material-line">
          <span class="material-title material-line-left">
            {{ $t('物料号') }}: {{item.materialNumber}}
          </span>
          <span class="material-line-right">
            <span class="label">{{ $t('锁定状态') }}</span>
            {{ item.blockStatus }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('库存数量') }}</span>
            {{ item.stock }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('西门子订货号') }}</span>
            {{ item.mlfb }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('列表价(不含税)') }}</span>
            {{ item.listPrice }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('最小订货数量') }}</span>
            {{ item.minOrderQuantity }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('单位') }}</span>
            {{ item.unit }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('产品来源') }}</span>
            {{ item.productType }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('物料类型') }}</span>
            {{ item.materialCategory }}
          </span>
        </p>
        <p class="material-line">
          <span class="material-line-left">
            <span class="label">{{ $t('预计货物到达西门子仓库日期') }}</span>
            {{ item.estArrivalDate }}
          </span>
        </p>
        <p class="material-line" v-if="restore[index]">
          <span class="material-line-left">
            <span class="label">{{ $t('最近三次补库记录') }}</span>
          </span>
        </p>
        <table class="table">
          <thead class="secondary">
            <th>{{ $t('补库日期') }}</th>
            <th>{{ $t('补库数量') }}</th>
          </thead>
          <tbody>
            <tr v-for="(row, col) of restore[index]" :key="col">
              <td>{{ row[0] }}</td>
              <td>{{ col[1] }}</td>
            </tr>
          </tbody>
        </table>
      </li>
    </ul>
  </page-container>
</template>

<script>
import { Loading } from 'vant'
import PageContainer from '../../../components/PageContainer'

export default {
  name: 'stock-query-result',
  components: {
    'van-loading': Loading,
    PageContainer
  },
  data () {
    return {
      updateDate: '',
      updateDateLoading: false,
      mode: this.$route.query.mode,
      conditions: {
        pageSize: 10,
        pageIndex: 1,
        number: this.$route.query.number
      },
      loading: false,
      list: [],
      finished: false
    }
  },
  computed: {
    api () {
      return this.$route.query.mode === 'order'
        ? this.$apis.order.getStockFuzzy
        : this.$apis.order.getStock
    },
    restore () {
      return this.list.reduce((res, curr, index) => {
        res[index] = this.getRestore(curr)
        return res
      }, [])
    }
  },
  methods: {
    getStock () {
      this.api(this.conditions, loading => (this.loading = loading))
        .then(res => {
          if (res && res.StockSet) {
            this.list = this.list.concat(res.StockSet)
            if (res.StockSet.length < 10) {
              this.finished = true
            }
            this.conditions.pageIndex += 1
          }
        })
    },
    getUpdateDate () {
      this.$apis.order.getStockUpdateDate(
        loading => (this.updateDateLoading = loading)
      ).then(res => {
        if (res) this.updateDate = res
      })
    },
    getRestore (stock) {
      const res = [
        ['', ''],
        ['', ''],
        ['', '']
      ]
      if (stock.RestockDate) {
        stock.RestockDate
          .split('|')
          .forEach((e, i) => (res[i][0] = e))
      }
      if (stock.RestockQuantity) {
        stock.RestockQuantity
          .split('|')
          .forEach((e, i) => (res[i][1] = e))
      }
      return res
    }
  },
  mounted () {
    this.getUpdateDate()
    this.getStock()
  }
}
</script>
